<!-- TItle.vue -->
<script lang="ts" setup>
import { computed } from 'vue';
import { DisplayStyle, TextDisplayStyle, TitleType, TitleDisplayStyle } from '../../Enums/UiEnums';
import { assertInternally } from '../../lib/Environment';
import { bootstrapTextClass } from '../../lib/StyleHelpers';
    const props = withDefaults(defineProps<
    {
        type: TitleType,
        displayStyle?: DisplayStyle | TextDisplayStyle,
        display?: TitleDisplayStyle
    }>(), 
    {
        type: TitleType.PageTitle,
        display: TitleDisplayStyle.Block,
    });

    const titleClass = computed<string>(() =>{
        switch(props.type)
        {
            case TitleType.PageTitle:
            case TitleType.HeadingSm:
            return "heading-sm";

            case TitleType.SectionTitle:
            case TitleType.BodyMd:
            return "label-isalus-medium";

            case TitleType.BodyLg:
            return "body-lg";

            case TitleType.SectionSubTitle:
            case TitleType.LabelSmProminent:
            return "label-isalus-small text-muted";

            case TitleType.BoldLabel:
            case TitleType.LabelMd:
            //return "fw-bold";
            return "label-md";

            case TitleType.LabelSm:
            case TitleType.SmallLabel:
            return "label-sm";

            case TitleType.PageBreadcrumb:
            case TitleType.BodyMdProminent:
                return "body-md-prominent";

            default:
                assertInternally(`Unhandled Title type: ${props.type}`);
                return "";
        }
    });

    const textClass = computed<string|undefined>(() =>{
        return bootstrapTextClass(props.displayStyle);
    });

</script>

<style scoped>
    
    .heading-sm {
        font-family: Figtree, var(--bs-body-font-family);
        font-size: 20px;
        font-weight: 700;
        line-height: 28px;
        text-align: left;        
    }

    .body-md-prominent
    {
        font-family: Inter, var(--bs-body-font-family);
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        text-align: left;
    }

    .body-lg
    {
        /* body-lg */
        font-family: Inter, var(--bs-body-font-family);;
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1.5rem; /* 150% */
    }

    .label-md
    {
        font-family: Inter, var(--bs-body-font-family);
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        text-align: left;        
    }

    .label-sm
    {
        font-family: Inter, var(--bs-body-font-family);;
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1rem; /* 133.333% */        
    }
</style>

<template>
    <div :class="[titleClass, textClass]" :style="{ display: props.display }">
        <slot></slot>
    </div>
</template>